type TableSkeletonProps = {
  /** Number of placeholder columns. Default 10. */
  columnCount?: number;
  /** Placeholder row count — enough to cover a typical viewport. Default 18. */
  rowCount?: number;
  /** Row height in pixels. Default 28, matching the live table. */
  rowHeight?: number;
};

// Varied bar widths so the field reads as a table, not a uniform block.
const BAR_WIDTHS = ['38%', '62%', '82%', '50%', '28%', '70%'];

/**
 * Generic loading skeleton for table routes: striped, pulsing placeholder rows
 * whose columns flex to fill their container. Wire it as a TanStack Router
 * `pendingComponent`, e.g. `pendingComponent: () => <TableSkeleton columnCount={14} />`.
 */
export function TableSkeleton({
  columnCount = 10,
  rowCount = 18,
  rowHeight = 28,
}: TableSkeletonProps) {
  return (
    <div className="w-full overflow-hidden">
      {Array.from({ length: rowCount }, (_, rowIndex) => (
        <div
          key={`skeleton-row-${rowIndex}`}
          className={`flex flex-row divide-x divide-gray-300 ${
            rowIndex % 2 === 0 ? 'bg-surface-row-odd' : 'bg-surface-row-even'
          }`}
          style={{ height: rowHeight }}
        >
          {Array.from({ length: columnCount }, (_, colIndex) => (
            <div
              key={`skeleton-cell-${rowIndex}-${colIndex}`}
              className="flex flex-1 items-center px-1"
            >
              <div
                className="h-2.5 rounded-sm bg-gray-300 animate-pulse motion-reduce:animate-none"
                style={{ width: BAR_WIDTHS[(rowIndex + colIndex) % BAR_WIDTHS.length] }}
              />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
